// extracted by mini-css-extract-plugin
module.exports = {"content":"AboutUsCommunity_content__LmZRU","imgWrapper":"AboutUsCommunity_imgWrapper__QDvET"};